<section
  [id]="data?.id"
  class="vm-row vm-text-section"
  [ngClass]="{
    'vm-row': !isModal,
    center:
      data?.type === globalElementType.TextSectionCenterAlignedWhiteBg ||
      data?.type === globalElementType.TextSectionCenterAligned
  }">
  <div *ngIf="data?.title && !isModal" class="vm-col-sm-12">
    <h2>
      {{ data?.title }}
    </h2>
  </div>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy" [ngClass]="{ 'vm-col-sm-12': !isModal }"></vm-markdown>
  <div [id]="item?.id" *ngFor="let item of data?.items">
    <div class="vm-row" *ngIf="item?.title">
      <h3>{{ item?.title }}</h3>
    </div>
    <div class="vm-row" *ngIf="item?.subTitle">
      <h4>{{ item?.subTitle }}</h4>
    </div>
    <div class="vm-row" *ngIf="item?.copy">
      <vm-markdown [data]="item?.copy"></vm-markdown>
    </div>
    <div class="vm-row" *ngIf="item?.iconSrc">
      <vm-media [source]="item?.iconSrc | mediaSrcStrapi: strapiUrl" [altText]="item?.alt"></vm-media>
    </div>
    <div class="vm-row" *ngIf="item?.media && item?.media?.length > 0 && item?.media[0]?.url">
      <iframe
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen=""
        [src]="item?.media[0]?.url | safeUrl"
        [title]="item?.media[0]?.alt"></iframe>
    </div>
  </div>
</section>
